<template>
  <div>
    <v-subheader>Outros Filtros</v-subheader>
    <v-layout wrap align-center>
      <status />
      <ordination />
    </v-layout>
  </div>
</template>
<script>
export default {
  name: 'Others',
  components: {
    Status: () => import('./Status.vue'),
    Ordination: () => import('./Ordination.vue'),
  },
};
</script>
